import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { StyleLoader } from '@sightworks/theme';
import clsx from 'clsx';
import Typography from '../../components/Typography';
import ArticleCreditsProps from './props';

const CreditsBlock = ({ classes, title, credits }: ArticleCreditsProps, ref: React.Ref<any>) => {
	return (
		<div className={classes.root} ref={ref}>
			{title && <Typography variant='h5'>{title}</Typography>}
			<div className={classes.content} dangerouslySetInnerHTML={{__html: credits}}/>
		</div>
	);
}

const Styles = makeStyles(theme => ({
	root: {},
	content: {}
}));

export default StyleLoader(CreditsBlock, Styles);

